/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { css, jsx } from '@atlaskit/css';

import type { ProviderIcon } from './useSmartLinkMetadata';

const providerIconImageStyles = css({
	display: 'inline-block',
	width: '16px',
	height: '16px',
	objectFit: 'contain',
});

/**
 * Renders a provider icon, accepting either a ready-to-render React node
 * (e.g. the Confluence/Jira logo elements returned by `extractSmartLinkProvider`)
 * or a remote image URL (e.g. a third-party provider PNG).
 */
export const ProviderIconView = ({
	icon,
}: {
	icon: ProviderIcon | undefined;
}): React.JSX.Element | null => {
	if (!icon) {
		return null;
	}
	if (icon.kind === 'url') {
		return <img css={providerIconImageStyles} src={icon.url} alt="" />;
	}
	return <React.Fragment>{icon.node}</React.Fragment>;
};
